import { deleted, get, post, put } from 'utils/api';
import { ListDate, ListStatusProduct } from './commonDate_services';
import { BASE_API_URL } from 'utils/constants';
import { DataResponse } from './response';

export type Moldmodel = {
  moldCode: string;
  moldName: string;
  serial: string;
};

export type WorkOrderModel = {
  stt: number;
  workOrderId: string;
  priority: number | null;
  parentWorkOrderCode: string;
  workOrderCode: string;
  productCode: string;
  productName: string;
  bomVersion: string;
  quantity: number;
  unit: string;
  documentDate: string;
  estimateFromDate: Date;
  estimateToDate: Date;
  actualStartDate?: Date;
  actualEndDate?: Date;
  poCode?: string;
  molds: Moldmodel[];
  printStatus: string;
  actived?: boolean;
  isUpdateMold: boolean;
  isEdit: boolean;

  statusMES: string;

  matchCard: string;
  matchCardId?: string;
  //   + Ngày yêu cầu hàng in về:
  printReqDate?: string;
  // + Hạng mục in:
  printItem?: string;
  // + Loại LSX:
  workOrderType?: string;
  // + Tên routing:
  routingName?: string;
  // + Khách hàng:
  customerName?: string;
  // + Kiểu in:
  printStyle?: string;
  // + Ngày giao hàng:
  deliveryDate?: string;
  // + Công ty gia công in:
  printCompany?: string;
  // + Đơn vị gia công thành phẩm:
  processingUnit?: string;
  // + Ghi chú sản xuất:
  attachedNote?: string;
  // + Tình trạng sản phẩm:
  productStatus?: string;
};

export interface Mold {
  moldCode: string;
  moldName: string;
  serial: string;
}

export type WorkOrderDetail = {
  paging: {
    pageIndex: number;
    pageSize: number;
    orderBy?: string;
    orderByDesc?: string;
  };
  parentWorkOrderCode?: string;
  productCode?: string;
  // productName: string;
  workOrderCode?: string;
  printStatus?: string;
  estimateFromDateFrom?: string;
  estimateFromDateTo?: string;
  // estimateDate?: ListDate;
  estimateDate?: string;
  documentDateFrom?: string;
  documentDateTo?: string;
  isUpdateMolde: boolean | null;
  productionStatusCode?: string;
  // productionStatusValue?: ListStatusProduct;
  // documentDate?: ListDate;
  documentDate?: string;
};

// export type WorkOrderResponse = {
//   data: Array<WorkOrderModel>;
//   isSuccess: boolean;
//   message: string;
//   recordsTotal: number;
//   resultsCount: number;
//   pagesCount: number;
// };

export type Paging = {
  pageIndex: number;
  pageSize: number;
};

// =========== Get By Work Order id=================//
export type WorkOrder = {
  id: string;
  moldCode: string;
  stepCode: string;
  productId: string;
};

// ===========Get danh sách khuôn kế hoạch của LSX ===========//
export type MoldByWorkOrder = {
  moldSelectedResponses: MoldSelectedResponsesModel[];
  moldNotSelectedResponses: MoldNotSelectedResponsesModel[];
};

export type MoldNotSelectedResponsesModel = {
  stt: number;
  productionInstruction: string;
  stepCode: string;
  stepName: string;
  moldCode: string;
  moldName: string;
  serial: string;
  isUpdate: boolean;
  orderIndex: number;
};

export type MoldSelectedResponsesModel = {
  id: string;
  stt: number;
  productionInstruction: string;
  stepCode: string;
  stepName: string;
  moldCode: string;
  moldName: string;
  serial: string;
  isUpdate: boolean;
  orderIndex: number;
};

// ================== Get danh sách sản phẩm theo khuôn ==============//
export type ProductByMold = {
  productId: string;
  // mã khuôn
  moldCode: string;
  // số serial
  serialNumber: string;
  // tình trạng khuôn
  statusMold?: any;
  filmCheck: string;
  moldTest: string | null;
  // tên khuôn
  moldName: string;
  stock?: any;
  bin: string;
  mainDate?: any;
  // số lượng dập lũy kế
  timeStamping?: any;
  // số lượng nhập cảnh báo
  stampQuantityAlert: number;
  // số lượng dập hiện tại
  currentStampQuantity: number;
  // mo ta
  description: string;
  // trạng thái
  actived: boolean;
  // kho khuôn
  locationNote: string;
};

// ================== Get thông tin để save barcode ==================//
export type saveBarcode = {
  workOderCode?: string;
  productName?: string;
  quantityPrinted?: number;
  quantity?: number;
};

export type dataPrint = {
  batchId: string | undefined;
  workOrderCardIds: string[] | undefined;
};

/// ================= Chi tiết lệnh sản xuất =========================//
export type Component = {
  component?: any;
  description?: any;
  quantity: number;
  unit: string;
  marquetteCode: string;
  size: number;
  sizePrint: number;
  quantityExport: number;
  quantityPaperCut: number;
  quantityPaperCutMin: number;
  colorParam: string;
  colorCode: string;
  printSpecifications: string;
  zincSize: string;
  zincNumber: number;
  note: string;
  outResource?: string;
};
export type WoMold = {
  moldCode: string;
  serialNumber: string;
  stepCode: string;
  orderIndex: string;
};
export type RoutingDetail = {
  step: string;
  // Mã Công đoạn
  stepCode: string;
  //  Tên công đoạn
  stepName: string;
  // Thứ tự công đoạn
  orderIndex: number;
  // Hướng dẫn sản xuất
  productionGuide: string;
  // Số lượng thực hiện theo từng công đoạn
  productPerStep: number;
  // Tổng số SP
  totalQuantity: number;
  // //  SL nhân công kế hoạch
  // slNhanCongKH?: number;
  // // SL máy móc kế hoạch
  // slMayMocKH?: number;
  stepSplit: string;
  // NVL sử dụng
  componentUsed: string;
  /* % Ước tính hoàn thành */
  estimateComplete: number;
  // Số SP/ Tờ/ Công đoạn
  productPerPage: number;
  isAllowDeleteMold: boolean;
  moldCode: string;
  // Thời gian định mức
  ratedTime: number;
  // Thời gian canh máy
  setupTime: number;
  soLuongGhiNhanDat: number;
  soLuongGhiNhanKhongDat: number;
  woRoutingId: string;
  // Số lượng công nhân kế hoạch
  quantityOfWorker: number;
  // Số lượng máy móc kế hoạch
  quantityEquipPerStep: number;

  // Khuôn
  molds: string[];
  mold2s?: { value: string; label: string }[];
  moldsName?: string[];

  // Thời gian canh máy
  tgCanhMay?: number;
  // chi phí bản kẽm
  chiPhiBanKem?: number;
  // chi phí gia công in offset
  chiPhiGiaCongInOffset?: number;
  slNhanCongCanhMay?: number
};

export type Molds = {
  moldCode: string;
  moldname: string;
};
export type InfoPallet = {
  workOrderCode: string;
  productName: string;
  quantityProduction: number;
  palletPrinted: number;
  detailInfoPallets: detailInfoPallets[];
  historyConfirmStage: historyConfirmStage[];
};
export type detailInfoPallets = {
  id: string;
  palletNumber: string;
  qtyByPallet: number;
  qtyRecordOK: number;
  qtyRecordNotOK: number;
  unit: string;
  stepName: string;
  productionGuide: string;
  status: string;
  createTime: string;
};
export type historyConfirmStage = {
  stt: number;
  stepCode: string;
  xnhtBy: string;
  xnhtTime: string;
  cancelXNHTBy?: string;
  cancelXNHTTime?: string;
  status: string;
};

export type WorkOrderDetailModel = {
  workOrderCode: string;
  parentWorkOrderCode: string;
  productCode: string;
  productName: string;
  bomVersion: string;
  quantity: number;
  documentDate: Date;
  estimateFromDate: Date;
  estimateToDate: Date;
  actualStartDate?: any;
  actualEndDate?: any;
  customerName?: any;
  poCode?: any;

  // so luong dat hang
  orderQty: number;
  // so luong giao mau
  sampleQty: number;
  unit: string;
  inforForm?: string;
  deliveryDate?: string;
  productSize?: any;
  productSpreadSize: string;
  printSize: number;
  processingUnit: string;
  // tinh trang san pham
  productStatus?: string;
  description?: string;
  // Tên routing
  routingName?: string;
  designVote: string;
  designBy: string;
  marquetteCode: string;
  moldDrawCode?: string;
  // ma ban ve
  drawCode: string;
  // quy cach dong goi
  specification?: string;
  // ghi chu san pham
  productNote: string;
  // loai lenh san xuat
  woType: string;
  // don vi tinh SO
  unitSO: string;
  attachedNote?: string;
  createBy?: string;
  matchCard: string;
  matchCardId?: string;

  // tên hạng mục in
  printItem: string;

  printStyle: string;
  printCompany: string;
  zincSupplier: string;
  printReqDate: Date;
  // trang thai
  printStatus: string;
  components: Component[];
  woMolds: WoMold[];
  routingDetails: RoutingDetail[];
  infoPallet: InfoPallet;
  // Trạng Thái MES
  productionStatus: string;
  productionStatusCode: string;
  // FSC
  fcs?: string;
};

// Update Trạng Thái MES
export type StatusMes = {
  description?: string;
  workorderCode?: string;
  productionStatus?: ListStatusProduct | null;
};

export type saveBarcodeModel = {
  batchId: string;
  workOrderCardIds: string[];
};

// interface cua Test Target
// khoi tao cac phuong thuc

export interface IWorkOrderServices {
  getListWorkOrder(data: any): Promise<DataResponse<Array<WorkOrderModel>>>;
  getByWorkOrderId(workOrderId: string): Promise<DataResponse<Array<WorkOrder>>>;
  getMoldByWO(workOrderId: string): Promise<DataResponse<MoldByWorkOrder>>;
  getProductByMold(productCode: string): Promise<DataResponse<Array<ProductByMold>>>;
  getInfoSaveBarcode(id: string): Promise<DataResponse<saveBarcode>>;
  saveBarcode(data: any): Promise<DataResponse<dataPrint>>;
  createWOMold(data: any): Promise<DataResponse<null>>;
  // chi tiết lệnh sản xuất
  getWorkOrderDetails(workOrderId: string): Promise<DataResponse<WorkOrderDetailModel>>;

  deleteWOMold(id: string): Promise<DataResponse<null>>;
  updateWORouting(data: object): Promise<DataResponse<null>>;
  // update Trạng thái MES
  updateProductionStatus(data?: StatusMes): Promise<DataResponse<null>>;

  createWOVS(data?: { description: string }): Promise<DataResponse<null>>;

  // save barcode in WorkOrder
  // saveBarcodeWO(data: object): Promise<DataResponse<saveBarcodeModel>>;
}

//ham khoi tao cac phuong thuc cua Test Target
export function createWorkOrderServices(): IWorkOrderServices {
  return {
    getListWorkOrder: async (data: any): Promise<DataResponse<Array<WorkOrderModel>>> => {
      return (await post(`MasterData/WorkOrder/SearchWO`, data)).data;
    },
    getByWorkOrderId: async (workOrderId: string): Promise<DataResponse<Array<WorkOrder>>> => {
      return (await get(`MasterData/WorkOrder/GetByWorkOrderId?workOrderId=${workOrderId}`)).data;
    },
    getMoldByWO: async (workOrderId: string): Promise<DataResponse<MoldByWorkOrder>> => {
      return (await get(`MasterData/WorkOrder/get-mold-by-wo?WorkOrderId=${workOrderId}`)).data;
    },
    getProductByMold: async (productCode: string): Promise<DataResponse<Array<ProductByMold>>> => {
      return (await get(`MasterData/WorkOrder/get-product-by-mold?ProductCode=${productCode}`)).data;
    },
    getInfoSaveBarcode: async (productId: string): Promise<DataResponse<saveBarcode>> => {
      return (await get(`MasterData/WorkOrder/get-info-save-barcode?WorkOrderId=${productId}`)).data;
    },
    saveBarcode: async (data: any): Promise<DataResponse<dataPrint>> => {
      return (await post(`MasterData/WorkOrder/save-barcode-wo`, data, BASE_API_URL)).data;
    },
    // saveBarcodeWO: async (data: object) => {
    //   return (await post(`MasterData/WorkOrder/save-barcode-wo`, data)).data;
    // },
    createWOMold: async (data: any): Promise<DataResponse<null>> => {
      return (await post(`MasterData/WorkOrder/CreateWOMold`, data)).data;
    },
    getWorkOrderDetails: async (workOrderId: string): Promise<DataResponse<WorkOrderDetailModel>> => {
      return (await get(`MasterData/WorkOrder/get-details-work-order?workOrderId=${workOrderId}`)).data;
    },
    deleteWOMold: async (id: string): Promise<DataResponse<null>> => {
      return (await deleted(`MasterData/WorkOrder/DeleteWOMold?Id=${id}`)).data;
    },
    updateWORouting: async (data): Promise<DataResponse<null>> => {
      return (await post(`MasterData/WorkOrder/update-wo-routing`, data)).data;
    },
    // update Trạng thái MES
    updateProductionStatus: async (data: StatusMes): Promise<DataResponse<null>> => {
      return (await put(`MasterData/WorkOrder/update-production-status`, data)).data;
    },

    // update Trạng thái MES
    createWOVS: async (data): Promise<DataResponse<null>> => {
      return (await post(`MasterData/WorkOrder/create-wo-vs`, data)).data;
    },
  };
}
